import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

/**
 * Generated class for the TimeHumanReadablePipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'timeHumanReadable',
})
export class TimeHumanReadablePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: Date, ...args) {
    let format = args && args.length > 0 ? args[0] : undefined;

    return moment.utc(value).format(format || "HH ч mm мин");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/time-human-readable/time-human-readable.ts